import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePageTitle } from '../hooks/usePageTitle'
import { useLang } from '../context/LangContext'
import qaraaCoffee from '../images/qaraacoffee.webp'
import { supabase } from '../supabaseClient'

export default function CoffeeDashboard() {
    usePageTitle('qaraa.coffee')
    const navigate = useNavigate()
    const { t, lang } = useLang()
    const [profileMenuOpen, setProfileMenuOpen] = useState(false)
    const [menuData, setMenuData] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        window.scrollTo(0, 0)
        fetchMenu()
        const interval = setInterval(() => { fetchMenu(true) }, 7000)
        return () => clearInterval(interval)
    }, [])

    const fetchMenu = async (silent = false) => {
        try {
            if (!silent) setLoading(true)
            const { data: cats } = await supabase.from('coffee_categories').select('*').order('sort_order')
            const { data: menu } = await supabase.from('coffee_menu').select('*').eq('is_available', true).order('sort_order')
            if (cats && menu) {
                const grouped = cats.map(cat => ({
                    category: cat.name,
                    items: menu.filter(item => item.category_id === cat.id)
                })).filter(g => g.items.length > 0)
                setMenuData(grouped)
            }
        } catch (err) {
            console.error('Error fetching menu:', err)
        } finally {
            setLoading(false)
        }
    }

    const handleLogout = () => {
        try { localStorage.removeItem('qaraa_customer') } catch (_) { }
        navigate('/')
    }

    const T = (kk, ru, en) =>
        lang === 'kk' ? kk : lang === 'ru' ? ru : en

    return (
        <div style={{ minHeight: '100vh', background: '#FFFFFF', fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif' }}>

            {/* ── HEADER ── */}
            <header style={{
                position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
                background: 'rgba(255,255,255,0.72)',
                backdropFilter: 'saturate(180%) blur(20px)',
                WebkitBackdropFilter: 'saturate(180%) blur(20px)',
                borderBottom: '1px solid rgba(0,0,0,0.08)'
            }}>
                <div style={{
                    maxWidth: '1440px', margin: '0 auto', padding: '0 48px',
                    height: '64px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                }}>
                    {/* Logo */}
                    <div
                        style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer', opacity: 1, transition: 'opacity 0.2s' }}
                        onClick={() => navigate('/dashboard')}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.7'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                    >
                        <img src={qaraaCoffee} alt="qaraa coffee" style={{ height: '36px', width: 'auto' }} />
                        <div>
                            <div style={{ fontSize: '16px', fontWeight: '600', color: '#1d1d1f', lineHeight: '1.2' }}>
                                qaraa.coffee
                            </div>
                            <div style={{ fontSize: '12px', color: '#8E8E93', marginTop: '2px' }}>
                                {T('Жаңа кофе және жайлы орта', 'Свежий кофе и уютная атмосфера', 'Fresh coffee & cozy atmosphere')}
                            </div>
                        </div>
                    </div>

                    {/* Nav right */}
                    <div style={{ position: 'relative' }}>
                        <button
                            onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                            style={{
                                padding: '8px 18px', background: 'transparent',
                                border: '1px solid rgba(0,0,0,0.12)', borderRadius: '980px',
                                fontSize: '14px', fontWeight: '600', color: '#1d1d1f',
                                cursor: 'pointer', transition: 'all 0.2s',
                                fontFamily: 'inherit'
                            }}
                            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(0,0,0,0.05)' }}
                            onMouseLeave={e => { e.currentTarget.style.background = 'transparent' }}
                        >
                            {T('Мәзір', 'Меню', 'Menu')} ↓
                        </button>

                        {profileMenuOpen && (
                            <div
                                onMouseLeave={() => setProfileMenuOpen(false)}
                                style={{
                                    position: 'absolute', top: 'calc(100% + 8px)', right: 0,
                                    background: 'rgba(255,255,255,0.96)',
                                    backdropFilter: 'blur(20px)',
                                    border: '1px solid rgba(0,0,0,0.1)',
                                    borderRadius: '14px',
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                    overflow: 'hidden', minWidth: '176px', zIndex: 200
                                }}
                            >
                                {[
                                    { label: T('Басты бет', 'Главная', 'Home'), action: () => navigate('/dashboard') },
                                    { label: T('Профиль', 'Профиль', 'Profile'), action: () => navigate('/profile') },
                                ].map((item, i) => (
                                    <button key={i}
                                        onClick={() => { setProfileMenuOpen(false); item.action() }}
                                        style={{
                                            width: '100%', padding: '12px 16px', background: 'transparent',
                                            border: 'none', borderBottom: '1px solid rgba(0,0,0,0.06)',
                                            textAlign: 'left', fontSize: '15px', fontWeight: '500',
                                            color: '#1d1d1f', cursor: 'pointer', transition: 'background 0.15s',
                                            fontFamily: 'inherit'
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.background = '#f5f5f7'}
                                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                                <button
                                    onClick={() => { setProfileMenuOpen(false); handleLogout() }}
                                    style={{
                                        width: '100%', padding: '12px 16px', background: 'transparent',
                                        border: 'none', textAlign: 'left', fontSize: '15px', fontWeight: '600',
                                        color: '#FF3B30', cursor: 'pointer', transition: 'background 0.15s',
                                        fontFamily: 'inherit'
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,59,48,0.06)'}
                                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                >
                                    {T('Шығу', 'Выйти', 'Log out')}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* ── HERO ── */}
            <section style={{
                paddingTop: '64px',
                background: '#FFFFFF'
            }}>
                <div style={{
                    maxWidth: '1440px', margin: '0 auto', padding: '80px 48px 100px',
                    display: 'grid', gridTemplateColumns: '1fr auto',
                    gap: '48px', alignItems: 'center'
                }}>
                    <div>
                        <div style={{
                            display: 'inline-flex', alignItems: 'center', gap: '6px',
                            padding: '5px 14px', borderRadius: '980px',
                            background: 'rgba(0,122,255,0.08)', marginBottom: '24px'
                        }}>
                            <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#34C759', display: 'inline-block' }} />
                            <span style={{ fontSize: '13px', fontWeight: '600', color: '#007AFF', letterSpacing: '-0.2px' }}>
                                {T('Жақында ашылады', 'Скоро открытие', 'Opening Soon')}
                            </span>
                        </div>
                        <h1 style={{
                            fontSize: '72px', fontWeight: '700', lineHeight: '1.05',
                            color: '#1d1d1f', letterSpacing: '-0.015em', marginBottom: '20px',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif'
                        }}>
                            {T('Мейірімді кофе.', 'Тёплый кофе.', 'Warm coffee.')}<br />
                            {T('Жайлы орта.', 'Уютная атмосфера.', 'Cozy atmosphere.')}
                        </h1>
                        <p style={{
                            fontSize: '21px', color: '#6e6e73', lineHeight: '1.5',
                            maxWidth: '480px', fontWeight: '400'
                        }}>
                            {T(
                                'qaraa.coffee-ке қош келдіңіз. Меню төменде.',
                                'Добро пожаловать в qaraa.coffee. Меню ниже.',
                                'Welcome to qaraa.coffee. Browse the menu below.'
                            )}
                        </p>
                    </div>
                    <div style={{
                        fontSize: '120px', lineHeight: 1,
                        filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.1))'
                    }}>
                        ☕
                    </div>
                </div>
            </section>

            {/* ── MENU SECTION ── */}
            <section style={{
                background: '#f5f5f7',
                borderRadius: '60px 60px 0 0',
                marginTop: '-40px',
                paddingTop: '80px',
                paddingBottom: '100px'
            }}>
                <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '0 48px' }}>

                    <h2 style={{
                        fontSize: '56px', fontWeight: '700', letterSpacing: '-0.015em',
                        color: '#1d1d1f', marginBottom: '12px',
                        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif'
                    }}>
                        {T('Мәзір', 'Меню', 'Menu')}
                    </h2>
                    <p style={{ fontSize: '19px', color: '#6e6e73', marginBottom: '64px', fontWeight: '400' }}>
                        {T('Барлық позициялар қолжетімді', 'Все позиции в наличии', 'All items available')}
                    </p>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '80px 0' }}>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '16px' }}>
                                {[0, 1, 2].map(i => (
                                    <div key={i} style={{
                                        width: '10px', height: '10px', borderRadius: '50%',
                                        background: '#007AFF', opacity: 0.3,
                                        animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`
                                    }} />
                                ))}
                            </div>
                            <div style={{ fontSize: '15px', color: '#8E8E93' }}>
                                {T('Жүктелуде...', 'Загрузка...', 'Loading...')}
                            </div>
                        </div>
                    ) : (
                        menuData.map((category, idx) => (
                            <div key={idx} style={{ marginBottom: '64px' }}>
                                {/* Category header */}
                                <div style={{
                                    display: 'flex', alignItems: 'baseline', gap: '14px',
                                    marginBottom: '24px', paddingBottom: '16px',
                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                }}>
                                    <h3 style={{
                                        fontSize: '34px', fontWeight: '700', color: '#1d1d1f',
                                        letterSpacing: '-0.01em',
                                        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif'
                                    }}>
                                        {category.category}
                                    </h3>
                                    <span style={{ fontSize: '15px', color: '#8E8E93', fontWeight: '500' }}>
                                        {category.items.length} {T('дана', 'позиции', 'items')}
                                    </span>
                                </div>

                                {/* Cards grid */}
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                    gap: '20px'
                                }}>
                                    {category.items.map((item) => (
                                        <div
                                            key={item.id}
                                            style={{
                                                background: '#FFFFFF',
                                                borderRadius: '18px',
                                                overflow: 'hidden',
                                                border: '1px solid rgba(0,0,0,0.04)',
                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                cursor: 'default'
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.transform = 'translateY(-4px)'
                                                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.08)'
                                                e.currentTarget.style.borderColor = 'rgba(0,0,0,0.08)'
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = 'translateY(0)'
                                                e.currentTarget.style.boxShadow = 'none'
                                                e.currentTarget.style.borderColor = 'rgba(0,0,0,0.04)'
                                            }}
                                        >
                                            {item.image_url && (
                                                <div style={{ width: '100%', height: '200px', overflow: 'hidden' }}>
                                                    <img
                                                        src={item.image_url}
                                                        alt={item.name}
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                                    />
                                                </div>
                                            )}
                                            <div style={{ padding: '24px' }}>
                                                <div style={{
                                                    display: 'flex', justifyContent: 'space-between',
                                                    alignItems: 'flex-start', gap: '12px', marginBottom: '8px'
                                                }}>
                                                    <h4 style={{
                                                        fontSize: '19px', fontWeight: '600', color: '#1d1d1f',
                                                        letterSpacing: '-0.01em', lineHeight: '1.25'
                                                    }}>
                                                        {item.name}
                                                    </h4>
                                                    <div style={{
                                                        fontSize: '17px', fontWeight: '700', color: '#007AFF',
                                                        whiteSpace: 'nowrap', flexShrink: 0
                                                    }}>
                                                        {item.price} ₸
                                                    </div>
                                                </div>
                                                {item.description && (
                                                    <p style={{
                                                        fontSize: '15px', color: '#6e6e73',
                                                        lineHeight: '1.47', fontWeight: '400', margin: 0
                                                    }}>
                                                        {item.description}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </section>

            {/* ── FOOTER INFO ── */}
            <footer style={{
                background: '#FFFFFF',
                borderRadius: '60px 60px 0 0',
                marginTop: '-40px',
                padding: '80px 48px 60px'
            }}>
                <div style={{ maxWidth: '1440px', margin: '0 auto' }}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '48px', marginBottom: '48px'
                    }}>
                        <div>
                            <img src={qaraaCoffee} alt="qaraa coffee" style={{ height: '40px', marginBottom: '16px', display: 'block' }} />
                            <div style={{ fontSize: '15px', color: '#6e6e73' }}>
                                {T('Жаңа кофе, жайлы орта', 'Свежий кофе, уютная атмосфера', 'Fresh coffee, cozy atmosphere')}
                            </div>
                        </div>
                        <div>
                            <div style={{ fontSize: '13px', fontWeight: '700', color: '#8E8E93', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '16px' }}>
                                {T('Ақпарат', 'Информация', 'Info')}
                            </div>
                            <div style={{ fontSize: '15px', color: '#1d1d1f', fontWeight: '500', marginBottom: '8px' }}>
                                📍 {T('Орналасқан жері: жақында', 'Адрес: скоро', 'Location: coming soon')}
                            </div>
                            <div style={{ fontSize: '15px', color: '#6e6e73' }}>
                                {T('Ашылу туралы жақында хабарланады', 'Следите за новостями', 'Stay tuned for the announcement')}
                            </div>
                        </div>
                    </div>
                    <div style={{
                        paddingTop: '32px',
                        borderTop: '1px solid rgba(0,0,0,0.08)',
                        fontSize: '13px', color: '#8E8E93', fontWeight: '500'
                    }}>
                        © 2026 qaraa.coffee — {T('Барлық құқықтар қорғалған', 'Все права защищены', 'All rights reserved')}
                    </div>
                </div>
            </footer>

            <style>{`
                @keyframes pulse {
                    0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
                    40% { opacity: 1; transform: scale(1); }
                }
                @media (max-width: 768px) {
                    h1 { font-size: 44px !important; }
                    h2 { font-size: 36px !important; }
                    section > div, footer > div { padding-left: 20px !important; padding-right: 20px !important; }
                    header > div { padding: 0 20px !important; }
                    section:first-of-type > div { grid-template-columns: 1fr !important; padding-top: 48px !important; padding-bottom: 60px !important; }
                    section:first-of-type > div > div:last-child { display: none; }
                }
            `}</style>
        </div>
    )
}